import { render, staticRenderFns } from "./StatisticCardLink.vue?vue&type=template&id=c42414b8"
import script from "./StatisticCardLink.vue?vue&type=script&lang=js"
export * from "./StatisticCardLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports